import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCharStatus } from "../../../../../app/patientSlice";

export const useCharStatus = () => {
  const dispatch = useDispatch();
  const characteristicTabsData = useSelector((s) => s.patient.minimumDatasetInfo?.characteristics);

  const updateCharStatus = useCallback(() => {
    if (characteristicTabsData?.length > 0) {
      const finalChar = characteristicTabsData.map((data) => data.isCompleted);
      dispatch(setCharStatus(finalChar));
    }
  }, [characteristicTabsData, dispatch]);

  useEffect(() => {
    updateCharStatus();
  }, [updateCharStatus]);

  return { updateCharStatus };
};
